import React, {useState, useEffect} from "react";
import { ChangeScheduleStatus } from "../../../Actions/StudentA";
import { useDispatch, useSelector } from "react-redux";
import SuccessStatusChangePopup from "./SuccessPopup";

const ChangeClassStatusPopup = ({setShowPopup, heading, text, btnText, onClick, imageSrc, statusPopupData, setError }) => {
  const [ClassFeedback, setClassFeedback] = useState("");
  const [classStatusChangeSuccessPopup, setClassStatusChangeSuccessPopup] = useState(false);

  const dispatch = useDispatch();

  const closePopup = () =>{
      console.log("Close icon clicked");
      setShowPopup(false);
  }

  const handleButtonClick = async () => {
    if (!ClassFeedback.trim()) {
        setError("Please enter feedback before submitting.");

         // Clear the error after 10 seconds
        setTimeout(() => {
            setError("");
        }, 10000);
  
        return;
      }
    
      setError(""); // Clear error if valid

      dispatch(ChangeScheduleStatus(statusPopupData.eventId, statusPopupData.status, ClassFeedback))
      .then((result) => {
        if (result?.success) {
          setClassStatusChangeSuccessPopup(true);
          // setShowPopup(false);
          // window.location.reload(); // ✅ Reload only if successful
        } else {
          console.error("Failed to change status:", result?.error);
        }
      })
      .catch((error) => {
        console.error("Dispatch error:", error);
      });
  };
  

    return (
      <div className="fixed inset-0 z-[999] flex items-center justify-center"
      style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)", // ⬅️ very light black background
            backdropFilter: "blur(4px)",           // ⬅️ optional blur
            WebkitBackdropFilter: "blur(4px)",     // ⬅️ Safari support
        }}>
        <div className="w-[360px] flex flex-col justify-center items-center relative rounded-[23px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-md">
          <div className="absolute top-2 right-2">
            <img
              className="absolute right-3 top-[6px] cursor-pointer"
              src={require("../Assets/Cross.svg").default}
              alt=""
              onClick={closePopup}
            />
          </div>

        {imageSrc && (
          <img
            src={imageSrc}
            alt="popup visual"
            className="mb-2 mt-[-60px] h-[220px]"
          />
        )}
          <h2
            className="mt-[-10px] mb-[5px] text-center text-[16px]"
          >
             {heading}
          </h2>
          <p className="text-center text-[14px] w-[280px]">{statusPopupData?.text}</p>
          <div className="w-full flex flex-col gap-[0px] mt-[10px]">
                <p className="text-[14px]">Feedback</p>
                <textarea
                    className=" mb-4 h-24 w-full resize-none rounded-md border border-gray-300 p-2 focus:outline-none "
                    placeholder="Add your feedback here..."
                    value={ClassFeedback}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 50) {
                            setClassFeedback(value);
                        }
                        }}
                />
                <p className="text-right text-[12px] text-gray-500 mt-[-10px]">
                {ClassFeedback.length}/50
                </p>
                {ClassFeedback.length > 50 && (
                <p className="text-[12px] text-red-500 mt-[-6px]">
                    Maximum 50 characters allowed.
                </p>
                )}

          </div>
          <div className="w-full flex justify-center items-center mt-[10px]">
            <button
                className="w-full h-[40px] rounded-[5px] bg-[#B5AAFF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleButtonClick}>
                {statusPopupData.btnText}
            </button>
          </div>
          <div className="w-full flex justify-center items-center mt-[10px]">
            <button
                className="text-[#000000] text-[14px] cursor-pointer"
                onClick={onClick}>
                Back
            </button>


            {classStatusChangeSuccessPopup && (
              <SuccessStatusChangePopup
                setShowPopup={setClassStatusChangeSuccessPopup}
                heading="Congratulations !!"
                text="Changes saved successfully."
                btnText="Done"
                onClick={() => setClassStatusChangeSuccessPopup(false)} // <-- Add this line
                imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
              />
          )} 
          </div>
        </div>
      </div>
    );
  };

export default ChangeClassStatusPopup;
